// extracted by mini-css-extract-plugin
export default {"container":"OldBrowserStub_container_fadc3","title":"OldBrowserStub_title_b97bc"};